import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LikeButton from '../facebookPage/FacebookLikeButton'; 
import FacebookPageEmbed from '../facebookPage/FacebookPageEmbed';

import axios from 'axios';



const Sidebar = () => {
  const [posts, setPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('https://ricgop.online/api/events.php')
      .then(res => {
        const fetchedPosts = Array.isArray(res.data.events)
          ? res.data.events
          : Array.isArray(res.data)
            ? res.data
            : [];

        // 🔴 Filter out specific events by ID
        const excludedIds = [5, 6, 7, 8]; // 👈 Add event IDs you want to hide
        const filteredPosts = fetchedPosts.filter(post => !excludedIds.includes(parseInt(post.id)));

        setPosts(filteredPosts);
      })
      .catch(err => {
        console.error('Failed to fetch events:', err);
      });
  }, []);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setSearchResults([]);
      return;
    }

    const filtered = posts.filter(post =>
      post.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(filtered);
  }, [searchTerm, posts]);

  const handleSearchSelect = (id) => {
    setSearchTerm('');
    setSearchResults([]);
    navigate(`/blog-details/${id}`);
  };

  return (
    <div className="sidebar-right">
      
      {/* Search */}
      <div className="sidebar-widget mb-45">
        <LikeButton />
        <h4 className="sidebar-widget-title mb-35">Search Here</h4>
        <div className="sidebar-search-box p-relative d-flex">
          <div className="sidebar-search-input position-relative w-100">
            <input
              type="text"
              placeholder="Search here"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-control"
              autoComplete="off"
            />
            {searchResults.length > 0 && (
              <ul
                className="search-suggestions position-absolute bg-white border shadow-sm mt-1 w-100 z-10"
                style={{ maxHeight: '200px', overflowY: 'auto', listStyleType: 'none', paddingLeft: 0, margin: 0 }}
              >
                {searchResults.map(post => (
                  <li
                    key={post.id}
                    className="p-2 border-bottom text-dark"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSearchSelect(post.id)}
                  >
                    {post.title}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
{/* Archive Link */}
<div 
  className="sidebar-widget mt-4 p-4 rounded-4 archive-link-card"
  style={{
    background: 'linear-gradient(135deg, #e3f2fd, #ffffff)',
    border: '1px solid #d0e3ff',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)'
  }}
>
  <h4 
    className="sidebar-widget-title mb-3" 
    style={{ color: '#0d6efd', fontWeight: '600', fontSize: '1.25rem' }}
  >
    📂 Explore More
  </h4>
  <ul className="list-unstyled m-0">
    <li>
      <Link 
        to="/archive"
        className="archive-link d-flex align-items-center gap-3 p-3 rounded-3"
        style={{
          backgroundColor: '#ffffff',
          color: '#0d6efd',
          fontWeight: '500',
          border: '1px solid #cfe2ff',
          boxShadow: 'inset 0 0 0 transparent',
          transition: 'all 0.3s ease',
          textDecoration: 'none'
        }}
      >
        <span role="img" aria-label="folder" style={{ fontSize: '1.5rem' }}>📁</span>
        <span style={{ fontSize: '1.05rem' }}>View Archive</span>
      </Link>
    </li>
  </ul>

  <style>{`
    .archive-link:hover {
      background-color: #0d6efd !important;
      color: white !important;
      transform: translateX(6px);
      box-shadow: inset 0 0 8px rgba(0,0,0,0.1);
    }
  `}</style>
</div>

<br></br>

      {/* Recent Posts */}
      <div className="sidebar-widget mb-45">
        <h4 className="sidebar-widget-title mb-40">Recent post:</h4>
        <div className="sidebar-widget-content">
          <div className="sidebar-widget-post">
            {posts.length > 0 ? (
              posts.map((event) => {
                const imageSrc = event.image_url?.startsWith('http')
                  ? event.image_url
                  : `/assets/img/${event.image_url}`;
                return (
                  <div key={event.id} className="rc-post mb-15 d-flex align-items-center">
                    <div className="rc-post-thumb mr-20">
                      <Link to={`/blog-details/${event.id}`}>
                        <img
                          src={imageSrc}
                          alt="Event"
                          style={{ width: '110px', height: 'auto', objectFit: 'cover' }}
                        />
                      </Link>
                    </div>
                    <div className="rc-post-content">
                      <h3 className="rc-post-title mb-15">
                        <Link to={`/blog-details/${event.id}`}>{event.title}</Link>
                      </h3>
                      <div className="rc-meta d-flex align-items-center">
                        <i className="flaticon-calendar me-2"></i>
                        <span className="me-2">{event.published_date}</span>
                        <span>{event.published_month}</span>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No recent events found.</p>
            )}
          </div>
        </div>
      </div>

      {/* Styles */}
      <style>{`/* Your full CSS remains the same, omitted here for brevity */`}</style>

      {/* Tags */}
      <div className="sidebar-widget">
        <div className="sideba-widge-title-box">
          <h3 className="sidebar-widget-title sm-border mb-35">Follow Us on Facebook</h3>
        </div>
        <div className="sidebar-widget-content">
         <div>
         <FacebookPageEmbed />
          
          </div>
        </div>
      </div>



    </div>
  );
};

export default Sidebar;
